'use client'

import { motion } from 'framer-motion'
import { Lock, Check } from 'lucide-react'
import { getPrimeiroNome } from '../utilitarios'
import { Step } from '@/hooks/useAppStore'

interface StepLgpdProps {
  nomeCompleto: string
  lgpdAceito: boolean
  setLgpdAceito: (valor: boolean) => void
  onSubmit: () => void
  onBack: () => void
}

export function StepLgpd({ nomeCompleto, lgpdAceito, setLgpdAceito, onSubmit, onBack }: StepLgpdProps) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-full max-w-md mx-auto">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-4 sm:mb-8">
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg shadow-purple-500/30">
          <Lock size={24} strokeWidth={1.5} className="text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-indigo-950 dark:text-white mb-2">Quase la, {getPrimeiroNome(nomeCompleto)}!</h2>
        <p className="text-indigo-950/50 dark:text-white/50 text-sm">Precisamos da sua autorizacao</p>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="space-y-4 sm:space-y-6">
        <label className="flex items-center gap-3 cursor-pointer group">
          <div className={`w-7 h-7 rounded-lg border-2 flex items-center justify-center shrink-0 transition-all ${lgpdAceito ? 'bg-purple-500 border-purple-500' : 'border-purple-500/20 dark:border-white/10 group-hover:border-purple-500/30 dark:border-white/20'}`}>
            {lgpdAceito && <Check size={16} className="text-white" />}
          </div>
          <input type="checkbox" checked={lgpdAceito} onChange={(e) => setLgpdAceito(e.target.checked)} className="sr-only" />
          <span className="text-sm text-indigo-950/70 dark:text-white/70">Li e aceito os <a href="/termos" target="_blank" className="text-purple-400 hover:text-purple-300 underline">termos de uso</a> e <a href="/privacidade" target="_blank" className="text-purple-400 hover:text-purple-300 underline">politica de privacidade</a></span>
        </label>
        <button onClick={onSubmit} disabled={!lgpdAceito} className={`w-full py-3.5 rounded-full font-medium text-sm transition-all ${lgpdAceito ? 'bg-purple-600 hover:bg-purple-500 text-white shadow-lg shadow-purple-600/25 active:scale-[0.98]' : 'bg-white/85 dark:bg-white/5 text-indigo-950/30 dark:text-white/30 cursor-not-allowed'}`}>Enviar solicitacao</button>
      </motion.div>
      <motion.button initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} onClick={onBack} className="mt-4 w-full text-center text-sm text-indigo-950/40 dark:text-white/40 hover:text-indigo-950/60 dark:text-white/60 transition-colors">&larr; Voltar</motion.button>
    </motion.div>
  )
}
